import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import Objective from "components/UnifiedProject/Objective/Objective";
import NextObjective from "components/Next/Objective/Objective";

import * as projectReducer from "containers/Project/reducer";
import * as viewReducer from "containers/View/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as runReducer from "containers/Run/reducer";
import * as adminReducer from "containers/Admin/reducer";
import * as globalReducer from "containers/App/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as deployReducer from "containers/Deployments/reducer";
import * as monitoringReducer from "containers/Monitoring/reducer";
import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";

export const getRunId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.runId
      ? props.match.params.runId
      : 2860;

class OptimizeContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  getIsActiveOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.activeSegment &&
      optimized.activeSegment.conditions.length === 0 &&
      optimized.activeSegment.job &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  render() {
    const {
      match,
      setup,
      aibleViewType,
      isTableauMode,
      project,
      optimized,
      optimizer,
      segmentOptions,
      modelGroups,
      updateDrilldownValue,
      isNext
    } = this.props;

    return setup !== undefined && Object.keys(setup).length > 0 ? (
      isNext ? (
        <NextObjective {...this.props} />
      ) : (
        <Objective {...this.props} />
      )
    ) : (
      <LoadingIndicator />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getRunId(ownProps);

  return {
    init: (aibleViewType) => dispatch(projectReducer.init(id, aibleViewType)),
    updateDrilldownValue: (runId, value) => dispatch(projectReducer.updateDrilldownValue(id, runId, value)),
    setMinBudget: (runId, budget) => dispatch(projectReducer.setSegmentMinBudgetByRunId(id, runId, budget)),
    setMaxBudget: (runId, budget) => dispatch(projectReducer.setSegmentMaxBudgetByRunId(id, runId, budget)),

    updateTruePositive: (runId, val) => {
      dispatch(setupReducer.updateTruePositive(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateFalsePositive: (runId, val) => {
      dispatch(setupReducer.updateFalsePositive(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateTrueNegative: (runId, val) => {
      dispatch(setupReducer.updateTrueNegative(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateFalseNegative: (runId, val) => {
      dispatch(setupReducer.updateFalseNegative(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateConversionGain: (runId, val) => {
      dispatch(setupReducer.updateConversionGain(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateConversionCost: (runId, val) => {
      dispatch(setupReducer.updateConversionCost(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateConversionMissed: (runId, val) => {
      dispatch(setupReducer.updateConversionMissed(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateConversionSaved: (runId, val) => {
      dispatch(setupReducer.updateConversionSaved(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },

    updateBaselineConversionGain: (runId, val) => {
      dispatch(setupReducer.updateBaselineConversionGain(runId, val));
      dispatch(projectReducer.resetBudget(id));
    },
    updateBaselineConversionCost: (runId, val) => {
      dispatch(setupReducer.updateBaselineConversionCost(runId, val));
      dispatch(projectReducer.resetBudget(id));
    },
    updateBaselineConversionMissed: (runId, val) => {
      dispatch(setupReducer.updateBaselineConversionMissed(runId, val));
      dispatch(projectReducer.resetBudget(id));
    },
    updateBaselineConversionSaved: (runId, val) => {
      dispatch(setupReducer.updateBaselineConversionSaved(runId, val));
      dispatch(projectReducer.resetBudget(id));
    },

    updateExpectedCountContinuous: (runId, val) => dispatch(setupReducer.updateExpectedCountContinuous(runId, val)),
    updateExpectedValueContinuous: (runId, val) => dispatch(setupReducer.updateExpectedValueContinuous(runId, val)),

    updateCustomValue: (runId, blueprintId, valId, value) => {
      dispatch(setupReducer.updateCustomValue(runId, blueprintId, valId, value));
      dispatch(projectReducer.resetBudget(id));
    },

    updateBaselineCustomValue: (runId, blueprintId, valId, value) => {
      dispatch(setupReducer.updateBaselineCustomValue(runId, blueprintId, valId, value));
      dispatch(projectReducer.resetBudget(id));
    },

    updateOutcomePercentage: (runId, percentage) => {
      dispatch(projectReducer.updateOutcomePercentage(id, runId, percentage));
    },

    updateIsRealityHammer: (runId, isRealityHammer) => {
      dispatch(setupReducer.updateIsRealityHammer(runId, isRealityHammer));
      dispatch(projectReducer.resetBudget(id));
    },

    updateScaledTotal: (runId, scaledTotal) => {
      dispatch(setupReducer.updateScaledTotal(runId, scaledTotal));
    },
    addUserRoleToSegment: (segmentId, userId, role) =>
      dispatch(projectReducer.addUserRoleToSegment(id, segmentId, userId, role)),
    deleteUserRoleFromSegment: (segmentRoleId) => dispatch(projectReducer.deleteUserRoleFromSegment(id, segmentRoleId)),
    deleteUserFromProject: (userId) => dispatch(projectReducer.deleteUserFromProject(id, userId)),
    patchUserRoleSegment: (segmentRoleId, role) =>
      dispatch(projectReducer.patchUserRoleSegment(id, segmentRoleId, role)),
    approveAssumption: (assumptionId) => dispatch(projectReducer.approveAssumption(id, assumptionId)),
    restoreAssumption: (assumptionId) => dispatch(projectReducer.restoreAssumption(id, assumptionId)),
    deleteAssumption: (assumptionId) => dispatch(projectReducer.deleteAssumption(id, assumptionId)),
    viewAssumption: (assumption) => dispatch(projectReducer.viewAssumption(id, assumption)),

    createSplits: (splitOne, splitTwo) => dispatch(projectReducer.createSplits(id, splitOne, splitTwo)),

    rerunSegment: (segmentId) => dispatch(projectReducer.rerunSegment(id, segmentId)),

    updateIsBusinessMode: (isBusiness) => dispatch(globalReducer.updateIsBusinessMode(isBusiness)),

    updateAibleViewType: (view) => dispatch(projectReducer.setAibleViewType(id, view)),

    updateIsBusinessReality: (runId, value) => dispatch(runReducer.updateIsBusinessReality(runId, value)),

    updateCompareScenarioIndex: (index) => dispatch(projectReducer.updateCompareScenarioIndex(id, index)),

    viewScenario: (scenario, index) => dispatch(projectReducer.viewScenario(id, scenario, index)),
    deleteScenario: () => dispatch(projectReducer.deleteScenario(id)),
    saveScenario: (name) => dispatch(projectReducer.saveScenario(id, name)),
    shortlistScenario: () => dispatch(projectReducer.shortlistScenario(id)),
    removeShortlist: () => dispatch(projectReducer.removeShortlist(id)),

    resetBudget: () => dispatch(projectReducer.resetBudget(id)),

    updateScaledTotal: (runId, s) => dispatch(setupReducer.updateScaledTotal(id, runId, s)),

    updateInnerId: (innerId) => dispatch(projectReducer.updateInnerId(id, innerId)),

    deploy: () => dispatch(projectReducer.deploy(id)),

    refresh: () => dispatch(projectReducer.refresh(id)),

    updateModelFeedback: (runId, modelId, isLiked) =>
      dispatch(projectReducer.updateModelFeedback(runId, modelId, isLiked)),

    updateTerminalConditions: (terminalConditions) =>
      dispatch(projectReducer.updateTerminalConditions(id, terminalConditions)),
    updateActivityConditions: (activityConditions) =>
      dispatch(projectReducer.updateActivityConditions(id, activityConditions)),
    updateUniqueId: (uniqueId) => dispatch(projectReducer.updateUniqueIdName(id, uniqueId)),
    updateFrontierPercentProcessedMin: (runId, frontierPercentProcessedMin) =>
      dispatch(setupReducer.updateFrontierPercentProcessedMin(runId, frontierPercentProcessedMin)),
    updateFrontierPercentProcessedMax: (runId, frontierPercentProcessedMax) =>
      dispatch(setupReducer.updateFrontierPercentProcessedMax(runId, frontierPercentProcessedMax)),
    setFrontierPercentProcessed: (value, useDefault) =>
      dispatch(setupReducer.setFrontierPercentProcessed(id, value, useDefault)),
    updateShowShortListed: (val) => dispatch(projectReducer.updateShowShortListed(id, val)),
    updateShowPending: (val) => dispatch(projectReducer.updateShowPending(id, val)),

    updateProjectMode: (val) => dispatch(projectReducer.updateProjectMode(id, val)),

    updateProjectSetting: (key, val) => dispatch(projectReducer.updateProjectSetting(id, key, val)),

    updateSliderView: (val) => dispatch(projectReducer.updateSliderView(id, val)),

    updateCurrentProjectId: (newId) => dispatch(globalReducer.updateCurrentProjectId(newId)),

    updateMonitorViewMode: (mode) => dispatch(monitoringReducer.updateMonitorViewMode(id, mode)),

    fetchMonitorData: () => dispatch(projectReducer.fetchMonitorData(id)),

    retrainProjectFromDataset: (datasetId) => dispatch(projectReducer.retrainProjectFromDataset(id, datasetId)),

    resetDatasetOutcome: () => dispatch(projectReducer.resetDatasetOutcome(id)),

    goToDeploy: () =>
      dispatch(
        unifiedProjectReducer.updateCurrentStep(ownProps.id, unifiedProjectReducer.UNIFIED_PROJECT_STEPS.DEPLOY.id)
      ),

    toggleCustomMapping: (runId, blueprintId, customFieldId) =>
      dispatch(setupReducer.toggleCustomMapping(runId, blueprintId, customFieldId)),

    updateAdvancedRevenueLabel: (runId, label) => dispatch(setupReducer.updateAdvancedRevenueLabel(runId, label)),
    updateAdvancedCostLabel: (runId, label) => dispatch(setupReducer.updateAdvancedCostLabel(runId, label)),
    updateNetImpactLabel: (runId, label) => dispatch(setupReducer.updateNetImpactLabel(runId, label)),
    updateFairnessObjective: (runId, fairnessObjective) => {
      dispatch(setupReducer.updateFairnessObjective(runId, fairnessObjective));
      dispatch(projectReducer.resetBudget(id));
    },
    updateFairnessToleranceBound: (runId, fairnessToleranceBound) => {
      dispatch(setupReducer.updateFairnessToleranceBound(runId, fairnessToleranceBound));
      dispatch(projectReducer.resetBudget(id));
    },
    recalculateBudget: () => dispatch(projectReducer.resetBudget(id)),
    updateBiasReduction: (runId, biasReduction) => {
      dispatch(setupReducer.updateBiasReduction(runId, biasReduction));
      dispatch(projectReducer.resetBudget(id));
    },

    updateTargetPositiveAllocation: (runId, targetPositiveAllocation) => {
      dispatch(setupReducer.updateTargetPositiveAllocation(runId, targetPositiveAllocation));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = getRunId(ownProps);

  const selectedRunId = projectReducer.getRunId(state, id);
  const innerRunId = projectReducer.getInnerId(state, id);
  const optimized = projectReducer.getOptimized(state, id);

  const runId =
    ownProps.isEditBlueprint && ownProps.editBlueprintId !== undefined
      ? ownProps.editBlueprintId
      : optimized && optimized.innerId !== undefined
        ? optimized.innerId
        : id;

  const setup =
    ownProps.isEditBlueprint && ownProps.editBlueprintId !== undefined
      ? setupReducer.getSetup(state, runId)
      : optimized && optimized.setup
        ? optimized.setup
        : setupReducer.getSetup(state, id);

  const models = runReducer.getTransformedSortedModels(state, selectedRunId);

  const selectedDataset = ownProps.selectedDataset
    ? ownProps.selectedDataset
    : setupReducer.getDatasetFromSetup(state, runId);
  const outcomeType = selectedDataset ? setupReducer.getOutcomeType(state, runId) : null;

  return {
    runId: runId,
    outcomeType: outcomeType,
    errorRuns: projectReducer.getErrorRuns(state, id),
    optimizer: projectReducer.getOptimizer(state, id),
    optimized: optimized,
    modelGroups: projectReducer.getModelGroups(state, id),

    isContinuous: setupReducer.getIsContinuous(state, runId),

    segmentOptions: projectReducer.getSegmentOptions(state, id),

    project: projectReducer.getProject(state, id),

    groupInfo: projectReducer.getGroupInfo(state, id),

    optimalProfit: projectReducer.getOptimalProfit(state, id),
    optimalCost: projectReducer.getOptimalCost(state, id),

    model: models && models.length > 0 ? models[0] : undefined,

    users: adminReducer.getUsers(state),

    runs: viewReducer.getRuns(state),

    continuousFrontier: projectReducer.getContinuousFrontier(state, id),

    aibleViewType: projectReducer.getAibleViewType(state, id),
    aibleViewTypeOptions: projectReducer.getAibleViewTypeOptions(state, id),

    isBusinessMode: globalReducer.getIsBusinessMode(state),
    isTableauMode: globalReducer.getIsTableauMode(state),

    isBusinessReality: runReducer.getIsBusinessReality(state, selectedRunId),
    isRealityHammer: setupReducer.getIsRealityHammer(state, runId),

    viewingScenarioIndex: projectReducer.getViewingScenarioIndex(state, id),
    compareScenarioIndex: projectReducer.getCompareScenarioIndex(state, id),

    selectedScenario: projectReducer.getSelectedScenario(state, id),

    allScenarios: projectReducer.getAllScenarios(state, id),

    scaledTotal: setupReducer.getScaledTotal(state, innerRunId),

    userName: loginReducer.getUserName(state),

    selectedDataset: setupReducer.getDatasetFromSetup(state, selectedRunId),
    terminalConditions: projectReducer.getTerminalConditions(state, id),
    activityConditions: projectReducer.getActivityConditions(state, id),
    uniqueId: projectReducer.getUniqueIdName(state, id),

    showShortListed: projectReducer.getShowShortListed(state, id),
    showPending: projectReducer.getShowPending(state, id),

    projectMode: projectReducer.getProjectMode(state, id),

    sliderView: projectReducer.getSliderView(state, id),
    deployment: deployReducer.getProjectDeployment(state, id),

    monitorViewMode: monitoringReducer.getMonitorViewMode(state, id),

    retrainDataset: projectReducer.getRetrainDataset(state, id),

    isMonitorFeedback: projectReducer.getIsMonitorFeedback(state, id),
    isMonitorRetrain: projectReducer.getIsMonitorRetrain(state, id),
    isAFO: projectReducer.getIsAFO(state, id),
    isSharing: projectReducer.getIsSharing(state, id),
    isLoadingSharing: projectReducer.getIsLoadingSharing(state, id),

    canManageSegmentPermissions: projectReducer.getSegmentManagePermissions(state, id),
    canEditSegments: projectReducer.getSegmentEditPermissions(state, id),

    setup: setup,
    blueprint: setupReducer.getBlueprintFromSetup(state, id),

    currentSpend: projectReducer.getCurrentSpend(state, id, runId),
    currentProfit: projectReducer.getCurrentProfit(state, id, runId),
    currentRevenue: projectReducer.getCurrentRevenue(state, id, runId),

    customFields: blueprintReducer.getCustomFieldsTransformed(state, setup ? setup.blueprintId : undefined),
    customMappings: setupReducer.getCustomMappings(state, runId),

    isEditBlueprint: unifiedProjectReducer.getIsEditBlueprint(state, id),

    dataset: setupReducer.getDatasetFromSetup(state, runId),
    isOptimizerWithinBounds: projectReducer.getOptimizerWithinBounds(state, id),
    fairnessToleranceBound: setupReducer.getFairnessToleranceBound(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(OptimizeContainer);
